import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-mb-1" }
const _hoisted_2 = { class: "tw-flex tw-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "tw-block tw-text-xs dark:tw-text-white"
}
const _hoisted_4 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-slate-500"
}
const _hoisted_5 = ["id", "data-testid"]
const _hoisted_6 = {
  key: 0,
  class: "tw-truncate tw-pr-[12px]"
}
const _hoisted_7 = { class: "tw-text-s tw-block tw-truncate tw-text-black dark:tw-text-white" }
const _hoisted_8 = {
  key: 0,
  class: "tw-block tw-truncate tw-text-xs tw-text-slate-500"
}
const _hoisted_9 = {
  key: 1,
  class: "tw-max-w-xs tw-truncate tw-pr-[12px]"
}
const _hoisted_10 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "tw-ml-auto tw-flex tw-max-w-[200px] tw-items-center tw-gap-2"
}
const _hoisted_12 = { class: "tw-truncate" }
const _hoisted_13 = {
  key: 0,
  id: "selected-value",
  class: "tw-block tw-truncate tw-text-xs tw-text-slate-500"
}
const _hoisted_14 = { ref: "dialog" }
const _hoisted_15 = ["data-testid"]
const _hoisted_16 = { class: "tw-sticky tw-top-0 tw-z-50 tw-w-full tw-bg-white tw-px-3 tw-pb-2 tw-pt-3 dark:tw-bg-black" }
const _hoisted_17 = {
  key: 0,
  class: "tw-flex tw-h-full tw-items-center tw-justify-center tw-py-4"
}
const _hoisted_18 = {
  key: 1,
  class: "tw-h-full"
}
const _hoisted_19 = {
  key: 1,
  class: "tw-grid tw-h-full tw-place-items-center tw-text-xs tw-text-slate-500"
}
const _hoisted_20 = ["id", "onClick"]
const _hoisted_21 = { class: "tw-flex tw-max-w-xs tw-flex-col tw-gap-1 tw-overflow-x-hidden" }
const _hoisted_22 = {
  key: 0,
  class: "tw-block tw-max-w-[200px] tw-truncate tw-text-xs tw-text-slate-500"
}
const _hoisted_23 = { class: "tw-truncate" }
const _hoisted_24 = {
  key: 2,
  class: "tw-ml-auto tw-flex tw-max-w-[200px] tw-items-center tw-gap-2"
}
const _hoisted_25 = { class: "tw-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioBadge = _resolveComponent("StudioBadge")!
  const _component_StudioSearchInput = _resolveComponent("StudioSearchInput")!
  const _component_StudioSpinner = _resolveComponent("StudioSpinner")!
  const _component_ThemeMoodBoard = _resolveComponent("ThemeMoodBoard")!
  const _directive_studio_click_outside = _resolveDirective("studio-click-outside")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "info")
      ]),
      (_ctx.subLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.subLabel), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      id: _ctx.id,
      ref: "selectedOption",
      class: _normalizeClass(["studio-advanced-select tw-mt-1 tw-flex tw-w-full tw-items-center tw-justify-between tw-rounded-md tw-border tw-bg-white tw-px-3 tw-py-2 tw-text-base dark:tw-bg-black sm:tw-text-sm", {
        'tw-cursor-pointer hover:tw-border hover:tw-border-deep-orange-500': !_ctx.disabled && !_ctx.isDropdownOpen,
        'tw-cursor-not-allowed': _ctx.disabled,
        'tw-border-transparent tw-ring-2 tw-ring-deep-orange-500': _ctx.isDropdownOpen
      }]),
      "data-testid": _ctx.id,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      (!_ctx.selectedOption || !_ctx.selectedOption.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.placeholder), 1),
            (!_ctx.hideSubtext)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Click to open"))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", {
                id: "selected-label",
                class: _normalizeClass(["tw-text-s tw-block tw-truncate tw-text-black dark:tw-text-white", {
              '!tw-text-slate-500': _ctx.disabled
            }])
              }, _toDisplayString(_ctx.selectedOption && _ctx.selectedOption.label), 3),
              (_ctx.selectedOption?.badges?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOption.badges, (badge) => {
                      return (_openBlock(), _createBlock(_component_StudioBadge, {
                        key: badge.label,
                        title: badge.label,
                        variation: badge.variation
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(badge.icon), { class: "tw-mr-1 tw-w-4" })),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(badge.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["title", "variation"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.hideSubtext)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.selectedOption && _ctx.getOptionSubLabel(_ctx.selectedOption)), 1))
              : _createCommentVNode("", true)
          ]))
    ], 10, _hoisted_5),
    _createElementVNode("dialog", _hoisted_14, [
      (_ctx.isDropdownOpen)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "options-dropdown",
            ref: "optionsDropdown",
            class: "tw-fixed tw-z-50 tw-mt-1 tw-flex tw-h-[300px] tw-flex-col tw-overflow-y-auto tw-rounded tw-border tw-border-slate-100 tw-bg-white tw-pb-1 tw-text-sm tw-shadow-sm dark:tw-border-slate-700 dark:tw-bg-black",
            "data-testid": _ctx.id + '-options'
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_StudioSearchInput, {
                id: "search-input",
                searchTerm: _ctx.searchTerm,
                alwaysExpanded: "",
                onOnSearch: _ctx.onSearch
              }, null, 8, ["searchTerm", "onOnSearch"])
            ]),
            (_ctx.isLoadingData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_StudioSpinner, { size: "small" })
                ]))
              : (_ctx.filteredOptions.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_ctx.$slots['empty-state'])
                      ? _renderSlot(_ctx.$slots, "empty-state", { key: 0 })
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, " No options found! "))
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredOptions, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                      id: `item-${option.value}`,
                      key: option.value,
                      class: _normalizeClass(["option tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-rounded tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-100 hover:tw-text-deep-orange-500", {
            '!tw-cursor-not-allowed': option.disabled,
            'tw-bg-slate-100 dark:tw-bg-slate-900': option.value === (_ctx.selectedOption && _ctx.selectedOption.value)
          }]),
                      onClick: ($event: any) => (_ctx.onSelectOption(option))
                    }, [
                      (typeof option.previewImage === 'object')
                        ? (_openBlock(), _createBlock(_component_ThemeMoodBoard, {
                            key: 0,
                            class: "tw-mr-2 tw-w-20",
                            themeObj: option.previewImage
                          }, null, 8, ["themeObj"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["tw-block tw-truncate tw-text-xs hover:tw-whitespace-normal", {
                'tw-text-deep-orange-500': option.value === (_ctx.selectedOption && _ctx.selectedOption.value),
                '!tw-text-slate-500': option.value !== (_ctx.selectedOption && _ctx.selectedOption.value) && option.disabled
              }])
                        }, _toDisplayString(option.label), 3),
                        (!_ctx.hideSubtext)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.getOptionSubLabel(option)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (option.badgeLabel)
                        ? (_openBlock(), _createBlock(_component_StudioBadge, {
                            key: 1,
                            title: option.badgeLabel,
                            variation: "gray",
                            class: "tw-ml-auto tw-max-w-[200px]"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_23, _toDisplayString(option.badgeLabel), 1)
                            ]),
                            _: 2
                          }, 1032, ["title"]))
                        : _createCommentVNode("", true),
                      (option?.badges?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.badges, (badge) => {
                              return (_openBlock(), _createBlock(_component_StudioBadge, {
                                key: badge.label,
                                title: badge.label,
                                variation: badge.variation
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(badge.icon), { class: "tw-mr-1 tw-w-4" })),
                                  _createElementVNode("p", _hoisted_25, _toDisplayString(badge.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["title", "variation"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_20))
                  }), 128)),
            (_ctx.showLoadMore)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "tw-mx-auto tw-cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('loadMore'))
                }, "Load More"))
              : _createCommentVNode("", true)
          ], 8, _hoisted_15)), [
            [_directive_studio_click_outside, _ctx.closeDropdown]
          ])
        : _createCommentVNode("", true)
    ], 512)
  ]))
}